<template>
    <FormSection title="Service Required" type="his-section" :full-height="false">
        <template v-slot:content>
            <section class="row py-3 g-0">
                <div class="form-group align-item-center col-12 col-lg-12 px-4 col-md-12 g-0">
                    <label class="mb-2 d-flex align-items-center">Service Required</label>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex flex-wrap">
                            <div
                                v-for="(service, index) in listOfService"
                                :key="index"
                                class="form-check col-4 custom-checkbox pb-2 pe-4"
                            >
                                <input
                                    type="checkbox"
                                    :value="String(index)"
                                    v-model="referral.Clinical.ServicesRequiredCollection"
                                    class="form-check-input"
                                    :id="service.name"
                                    @change="selectedServices"
                                />
                                <label class="form-check-label" :for="service.name">
                                    <small>{{ `${service.name} (${service.fullForm})` }}</small>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group d-flex col-12 pt-4">
                    <div class="form-group col-6 px-4">
                        <label for="height"> Height </label>
                        <span>
                            <div class="input-group d-flex w-100 flex-nowrap">
                                <div class="flex-grow-1">
                                    <input
                                        name="height"
                                        maxlength="9"
                                        class="form-control h-95 no-border-radius"
                                        type="text"
                                        placeholder="Enter Height"
                                        v-number-only
                                        @change="heightOnChange"
                                        v-model="referral.Clinical.Height"
                                    />
                                </div>
                                <div class="flex-row pb-0 rounded-1 input-group-text">
                                    <div class="form-check pe-2">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="in"
                                            value="1"
                                            v-model="referral.Clinical.HeightMetric"
                                        />
                                        <label class="form-check-label mb-2" for="in"> in </label>
                                    </div>
                                    <div class="form-check custom-radio">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="cm"
                                            value="2"
                                            v-model="referral.Clinical.HeightMetric"
                                        />
                                        <label class="form-check-label mb-2" for="cm"> cm </label>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                    <div class="form-group px-4 col-6">
                        <label for="weight"> Weight </label>
                        <span>
                            <div class="input-group d-flex w-100 flex-nowrap">
                                <div class="flex-grow-1">
                                    <input
                                        name="weight"
                                        maxlength="9"
                                        class="form-control h-95 no-border-radius"
                                        type="text"
                                        placeholder="Enter Weight"
                                        v-number-only
                                        @change="weightOnChange"
                                        v-model="referral.Clinical.Weight"
                                    />
                                </div>
                                <div class="flex-row pb-0 rounded-1 input-group-text">
                                    <div class="form-check pe-2">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="lb"
                                            value="1"
                                            v-model="referral.Clinical.WeightMetric"
                                        />

                                        <label class="form-check-label mb-2" for="lb"> lb </label>
                                    </div>
                                    <div class="form-check custom-radio">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="kg"
                                            value="2"
                                            v-model="referral.Clinical.WeightMetric"
                                        />
                                        <label class="form-check-label mb-2" for="kg"> kg </label>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>

                <div class="form-group col-12 col-lg-12 px-4 col-md-12 g-0">
                    <label class="mb-2 d-flex align-items-center">DME Needed</label>
                    <div class="d-flex flex-wrap">
                        <div
                            class="form-check col-4 custom-checkbox pb-2 pe-4"
                            v-for="([key, value], index) in enumToMap(dmeNeededEnum)"
                            :value="value.value"
                            :key="key"
                        >
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`dme-needed-${value.name}`"
                                :value="String(index)"
                                v-model="referral.Clinical.DMECollection"
                                @change="selectedDMEServices"
                            />
                            <label class="form-check-label" :for="`dme-needed-${value.name}`">
                                <small>{{ value.name }}</small>
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    v-if="referral.Clinical.DMECollection.includes('10')"
                    class="form-group col-12 col-lg-12 px-4 col-md-12 g-0"
                >
                    <input @change="onOtherDMEChange" v-model="referral.Clinical.OtherDME" />
                </div>
                <div class="form-group col-12 col-lg-12 px-4 col-md-12 g-0">
                    <label class="mb-2 d-flex align-items-center">Medication History</label>
                    <div class="form-check custom-checkbox pb-1">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="medication-history"
                            @change="medicationHistoryChange"
                            v-model="referral.Clinical.IsMedicationHistoryEnabled"
                        />
                        <label class="form-check-label" for="medication-history">
                            <small
                                >Patient consents to the agency utilizing the Surescripts Medication History interface
                                to pull a history of medications taken?
                            </small>
                        </label>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ServiceRequired.ts"></script>
